import { SlidersHorizontal } from "lucide-react-native";
import React from "react";
import { Box } from "../../ui/box";
import { Button, ButtonIcon, ButtonText } from "../../ui/button";
import { Text } from "../../ui/text";

interface FiltersButtonProps {
  count: number;
  onPress: () => void;
}

/** Filters trigger; shows the active-filter count badge when ≥1 is set. */
function FiltersButton({ count, onPress }: FiltersButtonProps) {
  const active = count > 0;
  return (
    <Button
      action="secondary"
      variant="outline"
      size="sm"
      rounded="lg"
      onPress={onPress}
      className={active ? "border-brand-300" : ""}
    >
      <ButtonIcon as={SlidersHorizontal} size="sm" />
      <ButtonText>Filtros</ButtonText>
      {active && (
        <Box className="ml-1 rounded-full bg-brand-500 px-1.5">
          <Text size="2xs" bold className="text-typography-0">
            {count}
          </Text>
        </Box>
      )}
    </Button>
  );
}

export default FiltersButton;
